module.exports = __webpack_public_path__ + "static/img/demo_activity.cacfd138.jpg";